import script from "./HandComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HandComponent.vue?vue&type=script&lang=ts&setup=true"

import "./HandComponent.vue?vue&type=style&index=0&id=b289bd60&scoped=true&lang=css"

import exportComponent from "/home/node/skat32-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b289bd60"]])

export default __exports__